import { Link } from "react-router-dom";
import styles from "./Hero.module.css";
import Icon from "./Icons";
import { hero } from "../data/content";
import useSiteSettings from "../hooks/useSiteSettings";
import portrait from "../Photos/AakashSharma.jpg";

export default function Hero() {
  const { doctor } = useSiteSettings();
  return (
    <section className={styles.hero}>
      {/* ambient wash — purely atmospheric */}
      <span className={styles.wash} aria-hidden="true" />

      <div className={`u-shell ${styles.grid}`}>
        <div className={styles.copy}>
          <p className={`u-eyebrow ${styles.eyebrow}`}>{hero.eyebrow}</p>

          <h1 className={styles.headline}>
            <span className={styles.line1}>{hero.headlineLead}</span>
            <span className={styles.line2}>
              Most of the work is <em className="u-em">finding it.</em>
            </span>
          </h1>

          <p className={styles.body}>{hero.body}</p>

          <div className={styles.ctaRow}>
            <Link to="/contact" className={styles.primary}>
              Book a consultation
              <Icon name="arrow" size={18} />
            </Link>
            <Link to="/treatments" className={styles.secondary}>
              See what I treat
            </Link>
          </div>

          <ul className={styles.focus}>
            {hero.focus.map((item) => (
              <li key={item.label} className={styles.focusItem}>
                <span className={styles.focusLabel}>{item.label}</span>
                <span className={styles.focusText}>{item.text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.portraitWrap}>
          <span className={styles.portraitPanel} aria-hidden="true" />
          <figure className={styles.portrait}>
            <img
              src={portrait}
              alt={`${doctor.name}, physiotherapist, seated in consultation`}
              width="640"
              height="640"
              loading="eager"
              decoding="async"
            />
          </figure>

          <figcaption className={styles.plate}>
            <span className={styles.plateName}>{doctor.name}</span>
            <span className={styles.plateRole}>
              {doctor.credential} · {doctor.role}
            </span>
          </figcaption>
        </div>
      </div>
    </section>
  );
}
